import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateStoreApi } from "../../services/store/update.store.api";
import { updateVoucherApi } from "../../services/vouchers/update.voucher.api";

export const useUpdateVoucherApi = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (infoUpdate: any) => updateVoucherApi(infoUpdate),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["vouchers"],
      });
    },
  });
};
